import Penetrator from './Penetrator';

export default Penetrator;
